import { Button, Input } from "@material-tailwind/react";
import axios from "axios";
import { useState } from "react";
import { useNavigate, useParams } from "react-router";
import { toast } from "react-toastify";

export default function ResetPage() {
	const routerParams = useParams();
	const [password, setPassword] = useState("");
	const [confirmPassword, setConfirmPassword] = useState("");
	const [resetCode, setResetCode] = useState("");
	const [error, setError] = useState("");
	const navigate = useNavigate();
	const email = routerParams.email;

	const submit = async (e) => {
		e.preventDefault();
		if (password !== confirmPassword) {
			setError("Passwords do not match");
			setTimeout(() => setError(""), 2000);
			return;
		}
		const { data } = await axios.post(
			`${process.env.REACT_APP_RELAY_API_HOST}/reset-password`,
			{
				userName: email,
				password,
				token: resetCode.trim(),
				usertype: "SUPER_ADMIN",
			},
		);
		if (!data.success) {
			console.error(data.error);
			setError(`Registration failed: ${data.error}`);
			setTimeout(() => setError(""), 2000);
			return;
		}
		toast.success("Password reset successfully!");
		navigate("/login");
	};

	return (
		<div className="flex flex-col justify-center px-6 lg:px-8 mt-36">
			<div className="sm:mx-auto sm:w-full sm:max-w-sm">
				<h2 className="mt-10 text-center text-2xl font-bold leading-9 tracking-tight text-gray-900">
					Password reset
				</h2>
				<h4 className="mt-2 text-center font-bold tracking-tight text-gray-700">
					Please check your email for your reset code
				</h4>
			</div>

			<div className="mt-5 sm:mx-auto sm:w-full sm:max-w-sm">
				<form onSubmit={submit} className="space-y-6">
					<div>
						<div>
							<div className="flex items-center justify-between"></div>
							<div className="mt-2">
								<Input
									label="Email"
									crossOrigin=""
									type="text"
									disabled
									value={email}
								/>
							</div>
						</div>
						<div>
							<div className="flex items-center justify-between"></div>
							<div className="mt-2">
								<Input
									label="New Password"
									crossOrigin=""
									type="password"
									required
									onChange={(e) => setPassword(e.target.value)}
								/>
							</div>
						</div>

						<div>
							<div className="flex items-center justify-between"></div>
							<div className="mt-2">
								<Input
									label="Confirm New Password"
									crossOrigin=""
									type="password"
									onChange={(e) => setConfirmPassword(e.target.value)}
									required
								/>
							</div>
						</div>

						<div>
							<div className="flex items-center justify-between"></div>
							<div className="mt-2">
								<Input
									label="Reset Code"
									crossOrigin=""
									type="text"
									onChange={(e) => setResetCode(e.target.value)}
									required
								/>
							</div>
						</div>
					</div>

					<div>
						<Button
							type="submit"
							className="flex w-full justify-center rounded-md bg-blue-700 px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm hover:bg-blue-800"
						>
							Reset
						</Button>

						{error && (
							<p className="text-center text-sm text-red-500 mt-4">{error}</p>
						)}
					</div>
				</form>
			</div>
		</div>
	);
}
